import { createFileRoute } from "@tanstack/react-router";
import { MaaledataValidatePage } from "@/features/maaledata/validering/MaaledataValidatePage";

export const Route = createFileRoute("/_app/_subheader/maalerdata/validering")({
  component: MaaledataValidatePage,
  head: () => ({
    meta: [
      {
        title: "Testområde | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
